import { IconButton as ChakraIconButton, ButtonProps } from '@chakra-ui/react';
import * as React from 'react';

import { Icon, iconNames } from 'shared_DEPRECATED/components/Icon';

export type CloseButtonProps = ButtonProps;

export const CloseButton = React.forwardRef<
  HTMLButtonElement,
  CloseButtonProps
>(function CloseButton(props, ref) {
  return (
    <ChakraIconButton variant="ghost" aria-label="Close" ref={ref} {...props}>
      {props.children ?? <Icon name={iconNames.cross} />}
    </ChakraIconButton>
  );
});
